/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import BtnLoader from "../BtnLoader/BtnLoader";
import SubmitButton from "./SubmitButton";
import { GoogleMap, MarkerF } from "@react-google-maps/api";

const Location = (props) => {
  const {
    loaders,
    handleSubmit,
    formData12,
    autoCompleteRef,
    setFormData12,
    setDrag,
    drag,
    setSelectedLocation,
    selectedLocation,
    formErrors,
    setFormErrors,
  } = props;
  const mapRef = useRef();
  let autoComplete;
  const handlePutAddress = (event) => {
    const { name, value } = event.target;
    setDrag((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleMarkerDragEnd = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setDrag({ lat, lng });
  };

  const handleInputChangeMap = (e) => {
    const { name, value } = e.target;
    setFormData12((prev) => ({
      ...prev,
      [name]: value,
    }));
    console.log(name, value, "query");
    if (value.trim() !== "") {
      setFormErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };
  const handlePlaceSelect = async () => {
    const addressObject = await autoComplete?.getPlace();
    const query = addressObject?.formatted_address;
    setFormData12((prev) => ({
      ...prev,
      address: query,
    }));
    if (addressObject?.geometry) {
      const latLng = {
        lat: addressObject.geometry.location.lat(),
        lng: addressObject.geometry.location.lng(),
      };
      setSelectedLocation(latLng);
      let updatedFormData = {};
      addressObject.address_components.forEach((component) => {
        const types = component.types;
        if (types.includes("street_number") || types.includes("route")) {
          updatedFormData.area = `${
            updatedFormData.area ? updatedFormData.area + " " : ""
          }${component.long_name}`;
        }
        if (types.includes("locality")) {
          updatedFormData.city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          updatedFormData.state = component.short_name;
        }
        if (types.includes("postal_code")) {
          updatedFormData.zipcode = component.long_name;
        }
        if (types.includes("country")) {
          updatedFormData.country = component.long_name;
        }
      });
      setFormData12((prev) => ({
        ...prev,
        ...updatedFormData,
      }));
      console.log(query, updatedFormData, "updatedFormData");
    }
  };

  const handleFindAddressClick = () => {
    if (drag.lat && drag.lng) {
      const lat = parseFloat(drag.lat);
      const lng = parseFloat(drag.lng);
      setSelectedLocation({ lat, lng });

      const geocoder = new window.google.maps.Geocoder();
      const latLng = { lat, lng };

      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;

          const updatedFormData = {
            ...formData12,
            address, // explicitly add address here
          };

          results[0].address_components.forEach((component) => {
            const types = component.types;

            if (types.includes("street_number") || types.includes("route")) {
              updatedFormData.area = `${
                updatedFormData.area ? updatedFormData.area + " " : ""
              }${component.long_name}`;
            }
            if (types.includes("locality")) {
              updatedFormData.city = component.long_name;
            }
            if (types.includes("administrative_area_level_1")) {
              updatedFormData.state = component.short_name;
            }
            if (types.includes("postal_code")) {
              updatedFormData.zipcode = component.long_name;
            }
            if (types.includes("country")) {
              updatedFormData.country = component.long_name;
            }
          });

          setFormData12(updatedFormData); // Set all components at once
        } else {
          console.log("Geocoder failed or no results found.");
        }
      });
    } else {
      console.log("Latitude and Longitude are not set.");
    }
  };

  // Update handlePlaceSelect for consistent state update

  const handleScriptLoad = (updateQuery, autoCompleteRef) => {
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      { types: ["geocode"] }
    );

    autoComplete.addListener("place_changed", () => {
      handlePlaceSelect(updateQuery);
    });
  };

  useEffect(() => {
    handleScriptLoad(setFormData12, autoCompleteRef);
  }, [autoCompleteRef]);
  const onMapLoad = (map) => {
    mapRef.current = map;
  };

  console.log(formData12, "formData12");

  return (
    <>
      <div className="grid md:grid-cols-12 gap-2">
        <div className="md:col-span-8 text-left">
          <label>Address</label> <br />
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-map-marker-alt" />
            <input
              type="text"
              ref={autoCompleteRef}
              name="address"
              onChange={handleInputChangeMap}
              placeholder="Enter the listing address."
              value={formData12?.address || ""}
              className="w-full"
            />
          </div>
          {formErrors.address && (
            <span className="error-message">{formErrors.address}</span>
          )}
        </div>
        <div className="md:col-span-4 text-left">
          <label>Apartment/Suite (optional)</label> <br />
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-building" />
            <input
              type="text"
              name="apt_suite"
              value={formData12.apt_suite}
              onChange={handleInputChangeMap}
              placeholder="Apartment/Suite"
            />
          </div>
        </div>
        <div className="md:col-span-4 text-left">
          <label>City</label>
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-city" />
            <input
              type="text"
              name="city"
              value={formData12.city}
              onChange={handleInputChangeMap}
              placeholder="City"
            />
          </div>
          {!formData12.city && formErrors.city && (
            <span className="error-message">{formErrors.city}</span>
          )}
        </div>
        <div className="md:col-span-4 text-left">
          <label>State</label>
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-map" />
            <input
              type="text"
              name="state"
              value={formData12.state}
              onChange={handleInputChangeMap}
              placeholder="State"
            />
          </div>
          {!formData12.state && formErrors.state && (
            <span className="error-message">{formErrors.state}</span>
          )}
        </div>
        <div className="md:col-span-4 text-left">
          <label>ZIP / Postal Code</label>
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-mail-bulk" />
            <input
              type="text"
              name="zipcode"
              value={formData12.zipcode}
              onChange={handleInputChangeMap}
              placeholder="ZIP / Postal Code"
            />
          </div>
          {!formData12.zipcode && formErrors.zipcode && (
            <span className="error-message">{formErrors.zipcode}</span>
          )}
        </div>
        <div className="md:col-span-4 text-left">
          <label>Area (optional)</label>
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-map-marked-alt" />
            <input
              type="text"
              name="area"
              value={formData12.area}
              onChange={handleInputChangeMap}
              placeholder="Area"
            />
          </div>
        </div>
        <div className="md:col-span-4 text-left">
          <label>Country</label>
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-globe" />
            <input
              type="text"
              name="country"
              value={formData12.country}
              onChange={handleInputChangeMap}
              placeholder="Country"
            />
          </div>
          {!formData12.country && formErrors.country && (
            <span className="error-message">{formErrors.country}</span>
          )}
        </div>

        <div className="md:col-span-12">
          <GoogleMap
            mapContainerStyle={{ height: "500px" }}
            center={selectedLocation}
            zoom={10}
            onLoad={onMapLoad}
          >
            <MarkerF
              draggable={true}
              onDragEnd={(e) => handleMarkerDragEnd(e)}
              position={selectedLocation}
            />
          </GoogleMap>
        </div>

        <div className="md:col-span-12 text-left">
          <h3>Find the address on map.</h3>
        </div>
        <div className="md:col-span-4 text-left">
          <label>Lattitude</label>
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-globe" />
            <input
              type="text"
              name="lat"
              value={drag?.lat || ""}
              placeholder="Lattitude"
              onChange={handlePutAddress}
            />
          </div>
        </div>
        <div className="md:col-span-4 text-left">
          <label>Longitude</label>
          <div className="flex border border-input px-3 py-3 rounded-md gap-4 items-center">
            <i className="fal fa-globe" />
            <input
              type="text"
              name="lng"
              value={drag?.lng || ""}
              placeholder="Longitude"
              onChange={handlePutAddress}
            />
          </div>
        </div>
        <div
          onClick={handleFindAddressClick}
          className="md:col-span-4 text-left border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white
          h-10 mt-5 flex justify-center items-center"
        >
          Find Address
        </div>
        <div className="md:col-span-4 text-left">
          <SubmitButton handleSubmit={handleSubmit} loaders={loaders} />
        </div>
        <div className="md:col-span-4 text-left">
          <button className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3">
            {loaders ? <BtnLoader /> : <>Save as Draft</>}
          </button>
        </div>
      </div>
    </>
  );
};

export default Location;
